import { controlComponentsDetail, addControlComponents, editControlComponents } from './../request';
import { getSplitFun } from './../utils';
import { cryptoDecrypt } from '@/utils/aes';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { controlsSource } from './../../dataSourceManage/request';
export default {
  data() {
    return {
      action: uploadFile,
      dataFrom: {},
      dialogVisible: false,
      loading: false,
      controlsList: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('数据源名称')
        }],
        mark: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('标识')
        }],
        icon: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请上传') + this.$t('icon')
        }]
      };
    }
  },
  methods: {
    async init(val) {
      if (val.id) {
        const res = await controlComponentsDetail({
          componentsId: val.id
        });
        this.dataFrom = {
          componentsId: res.id,
          controlsId: res.controlsId,
          name: res.name,
          mark: res.mark,
          icon: res.icon,
          controlsSourceId: getSplitFun(res.controlsSourceId)
        };
      } else {
        this.dataFrom = {
          controlsId: val.controlsId,
          controlsSourceId: []
        };
      }
      this.controlsList = await controlsSource({
        controlsId: val.controlsId
      });
      this.dialogVisible = true;
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    handleChange({
      file
    }) {
      if (file.status === 'uploading') {
        this.loading = true;
        return;
      }
      if (file.status === 'done') {
        this.dataFrom.icon = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        this.loading = false;
      }
    },
    handleSure() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          const FUN = this.dataFrom.componentsId ? editControlComponents : addControlComponents;
          let formData = recursionCopy(this.dataFrom);
          if (formData.controlsSourceId.length != 0) {
            formData.controlsSourceId = formData.controlsSourceId.join(',');
          } else {
            formData.controlsSourceId = '';
          }
          await FUN(formData);
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          this.$emit('cancel');
        }
      });
    }
  }
};